import { memo, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { useKnmDocumentAttachment } from 'KnmPackage/MainModule/hooks/useKnmDocumentAttachment';
import { KnmSignDocumentModal } from 'KnmPackage/KnmDocumentsModule/components/KnmSignDocumentModal';
import { IKnmAttachmentDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmAttachmentDocument';

import { KnmAttachmentsListWithoutForm } from '../KnmAttachmentsListWithoutForm';

interface IAttachmentsProps {
  acceptedFiles?: string;
  closeSignModal: () => void;
  isVisibleSignModal: boolean;
  addAttachment: (data: IKnmAttachmentDocument) => void;
  removeField: () => void;
  values: IKnmAttachmentDocument[];
}

export const Attachments = memo(
  ({ acceptedFiles, closeSignModal, isVisibleSignModal, addAttachment, removeField, values }: IAttachmentsProps) => {
    const { uploadKnmDocumentAttachment } = useKnmDocumentAttachment();

    const handleSaveSignedDocument = useCallback(
      async (signedDocument: File) => {
        const listId = uuidv4();

        const attachment = await uploadKnmDocumentAttachment(signedDocument);

        addAttachment({
          fileName: signedDocument.name,
          filePath: attachment.filePath,
          mimeType: attachment.mimeType,
          bucketName: attachment.bucketName,
          fileSize: signedDocument.size,
          isNew: true,
          listId,
          file: signedDocument,
        });

        closeSignModal();
      },
      [addAttachment, closeSignModal, uploadKnmDocumentAttachment],
    );

    return (
      <>
        <KnmAttachmentsListWithoutForm values={values} isWatchOnly={false} removeField={() => removeField()} />
        <KnmSignDocumentModal
          isVisibleModal={isVisibleSignModal}
          fieldName={''}
          onCloseSignModal={closeSignModal}
          onSaveSignedDocument={handleSaveSignedDocument}
          isWatchOnly={false}
          acceptedFiles={acceptedFiles}
        />
      </>
    );
  },
);
